function c(t) {
  return Number.parseInt(t, 16) || 0;
}
function r(t) {
  return c(t) / 255 <= 0.03928 ? c(t) / 255 / 12.92 : ((c(t) / 255 + 0.055) / 1.055) ** 2.4;
}
function u(t) {
  return 0.2126 * r(t.slice(1, 3)) + 0.7152 * r(t.slice(3, 5)) + 0.0722 * r(t.slice(-2));
}
function i(t, e) {
  const n = u(t), s = u(e);
  return (Math.max(n, s) + 0.05) / (Math.min(n, s) + 0.05);
}
function o(t, e, n) {
  const s = i(t, e), a = i(t, n);
  return s > a ? e : n;
}
export {
  o as getTextColorBasedOnBgColor
};
